import React, { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { AdminShell } from "@/components/admin/AdminShell";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { AdminProducts } from "@/components/admin/AdminProducts";
import { OrderTable } from "@/components/admin/OrderTable";
import { AdminCustomers } from "@/components/admin/AdminCustomers";
import { AdminCoupons } from "@/components/admin/AdminCoupons";
import { CmsManager } from "@/components/admin/CmsManager";

export default function Admin() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Redirect if not authorized
  useEffect(() => {
    if (!authLoading) {
      if (!user || (user.email?.toLowerCase() !== "yedageshantanu@gmail.com" && user.role !== "admin")) {
        toast.error("Access denied. Admin privileges required.");
        navigate("/");
      }
    }
  }, [user, authLoading, navigate]);

  if (authLoading || !user) {
    return (
      <main className="pt-32 min-h-screen bg-[#FAF8F5] grid place-items-center">
        <div className="text-center">
          <div className="w-12 h-12 rounded-full border-4 border-gold border-t-transparent animate-spin mx-auto mb-4" />
          <p className="font-display font-medium text-[#1C1924]">Verifying credentials...</p>
        </div>
      </main>
    );
  }

  // Determine active component based on React Router path
  let content = <AdminDashboard />;
  if (pathname.startsWith("/admin/products")) {
    content = <AdminProducts />;
  } else if (pathname.startsWith("/admin/orders")) {
    content = <OrderTable />;
  } else if (pathname.startsWith("/admin/customers")) {
    content = <AdminCustomers />;
  } else if (pathname.startsWith("/admin/coupons")) {
    content = <AdminCoupons />;
  } else if (pathname.startsWith("/admin/content")) {
    content = <CmsManager />;
  }

  return (
    <AdminShell>
      {content}
    </AdminShell>
  );
}
